import {create} from 'zustand';
import {OdontoTermDrawerStore} from './types';

export const useOdontoTermDrawerStore = create<OdontoTermDrawerStore>(set => ({
	isDismissed: false,
	dismissDrawer: () => set({isDismissed: true}),
}));
